/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsEGameOrientation, FxIdDomainSettingsEGameOrientationFromJSONTyped, FxIdDomainSettingsEGameOrientationToJSON, } from './FxIdDomainSettingsEGameOrientation';
export function FxIdWebFeaturesPlayGameResponseMobileGameOrientationFromJSON(json) {
    return FxIdWebFeaturesPlayGameResponseMobileGameOrientationFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseMobileGameOrientationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsEGameOrientation(json)) {
        return FxIdDomainSettingsEGameOrientationFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesPlayGameResponseMobileGameOrientationToJSON(json) {
    return FxIdWebFeaturesPlayGameResponseMobileGameOrientationToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseMobileGameOrientationToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsEGameOrientation(value)) {
        return FxIdDomainSettingsEGameOrientationToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesPlayGameResponseMobileGameOrientation.js.map